module.exports = "https://web-assets.ifttt.com/packs/media/partners/copy-203f5de4.svg";